import React from "react";

import { CreateFieldBox } from "../../containers";

export const CreateFieldPage = () => {
  return (
    <div>
      <CreateFieldBox />
    </div>
  );
};
